module.exports = "/_next/static/images/phi-2x-1beb8aae9d0f0bcfedf0a1f1c0340683.jpg.webp";